export const USD_MULTIPLIER = 1.16;

export const GBP_MULTIPLIER = 0.89;
